var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2872 12.4916C23.3027 18.604 18.399 23.5919 12.2872 23.6806C9.38996 23.7242 6.59591 22.6057 4.52904 20.5749C2.46217 18.5441 1.29466 15.7702 1.28723 12.8726C1.27016 6.75904 6.17429 1.76931 12.2872 1.6806C15.1849 1.63728 17.9793 2.75627 20.0462 4.78765C22.1131 6.81903 23.2803 9.59358 23.2872 12.4916Z",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2872 14.6856V7.6856",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2782 16.6856C12.2122 16.6866 12.1493 16.7143 12.104 16.7623C12.0586 16.8103 12.0345 16.8746 12.0372 16.9406C12.0421 17.077 12.1538 17.1851 12.2902 17.1856V17.1856C12.3562 17.1843 12.4189 17.1566 12.4642 17.1086C12.5095 17.0607 12.5336 16.9965 12.5312 16.9306C12.5271 16.7974 12.4204 16.6903 12.2872 16.6856H12.2822",
    stroke: "#D50000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5c40dc7cc6932e9ce5be8c713abd892d.svg";
export { ForwardRef as ReactComponent };